import { type TagColor } from '@/components/Tag/Tag'
import i18n from '@/i18n'

export const getAbsencesStatusTag = (
  value: 'absent_unexcused' | ''
): { color: TagColor; label: string } => {
  switch (value) {
    case 'absent_unexcused':
      return {
        color: 'red',
        label: i18n.t('statuses.unexcused', { ns: 'absences2' })
      }
    default:
      return {
        color: 'gray',
        label: i18n.t('statuses.unverified', { ns: 'absences2' })
      }
  }
}
